import { getEnv } from '@ctct/ctct-helpers';

import { BaseApiClient } from '../BaseApiClient';

export type StripePortalDetailsPayload = {
  returnUrl: string;
  flowType?: 'payment_method_update' | 'subscription_cancel' | 'subscription_update' | 'subscription_update_confirm';
};

class StripeAccountApi {
  private baseApiClient: BaseApiClient;

  private baseUrl: string;

  constructor() {
    this.baseUrl = `https://app${getEnv()}constantcontact.com/v1/stripe`;
    this.baseApiClient = new BaseApiClient(this.baseUrl);
  }

  public async getStripeCustomer() {
    return this.baseApiClient.get<unknown>('/customer');
  }

  public async getScheduledDowngrade() {
    return this.baseApiClient.get<unknown>('/scheduled-downgrade');
  }

  public async deleteScheduledDowngrade() {
    return this.baseApiClient.delete<unknown>('/scheduled-downgrade');
  }

  public async getStripeCustomerPortalDetails(body: StripePortalDetailsPayload) {
    return this.baseApiClient.post('/portal', body);
  }
}

/**
 * Represents an API for working with the customer's Stripe account.
 *
 * For working with the Stripe Elements client-side SDK, use `stripeApi` instead.
 */
export const stripeAccountApi = new StripeAccountApi();
